
export const NAME = 'Modal';
